import React, { useState, useRef, useEffect } from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const FullscreenWrapper = ({ children }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const containerRef = useRef(null);
  const { theme } = useTheme();

  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  const toggleFullscreen = async () => {
    if (!document.fullscreenElement) {
      await containerRef.current.requestFullscreen();
      setIsFullscreen(true);
      
      // Lock to landscape on mobile
      //if (isMobile() && window.screen.orientation && window.screen.orientation.lock) {
      //  try {
      //    await window.screen.orientation.lock('landscape');
      //  } catch (err) {
      //    console.log('Failed to lock orientation:', err);
      //  }
      //}
    } else {
      if (document.exitFullscreen) {
        await document.exitFullscreen();
        setIsFullscreen(false);
        
        // Unlock orientation on mobile
        if (isMobile() && window.screen.orientation && window.screen.orientation.unlock) {
          try {
            await window.screen.orientation.unlock();
          } catch (err) {
            console.log('Failed to unlock orientation:', err);
          }
        }
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFullscreenNow = !!document.fullscreenElement;
      setIsFullscreen(isFullscreenNow);
      
      // Handle orientation when exiting fullscreen via escape key
      if (!isFullscreenNow && isMobile() && window.screen.orientation && window.screen.orientation.unlock) {
        window.screen.orientation.unlock().catch(err => {
          console.log('Failed to unlock orientation:', err);
        });
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  return (
    <div ref={containerRef} className="z-auto">
      <div className={`${isFullscreen ? 'fixed inset-0 overflow-hidden' : ''} ${theme === 'light' ? 'bg-white' : 'bg-gray-900'}`}>
        {children}
        <button
          onClick={toggleFullscreen}
          className={`fixed bottom-4 md:left-3 left-0 p-2 rounded-r-full md:rounded-full ${
            theme === 'light' 
              ? 'bg-gray-200 hover:bg-gray-300' 
              : 'bg-gray-700 hover:bg-gray-600'
          } transition-colors duration-200`}
          aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
          title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
        >
          {isFullscreen ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
};

export default FullscreenWrapper;